// @ts-nocheck
import { Box, Dialog as MDialog, DialogContent, IconButton, Typography } from '@mui/material';
import { Close, FileDownloadOutlined } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

import { Themes } from '../../../constants';
import { FORTA_BLUE, FORTA_WHITE } from '../../../utils/colors';
import { getThemeColor } from '../../../utils/common';
import { FH_PREVIEW_DIALOG_CONTENT_SX, FH_PREVIEW_DIALOG_HEADER_SX } from './styles';

import type { DialogProps as MDialogProps } from '@mui/material';
import type { ReactNode } from 'react';

interface FHPreviewDialogProps extends MDialogProps {
  title?: string;
  header?: string | ReactNode;
  submitLoading?: boolean;
  colorTheme?: Themes;
  contentRenderer?: () => ReactNode;
  dialogStyles?: any;
  headerStyles?: any;
  titleStyles?: any;
  closeIconDataTestId?: string;
  dialogHeight?: number;
  showDownload?: boolean;
  onDownload?: () => void;
}

const StyledDialog = styled(MDialog, {
  shouldForwardProp: (prop) => prop !== 'colorTheme',
})<FHPreviewDialogProps>(({ dialogStyles, sx, dialogHeight = '90%' }: any) => ({
  '& .MuiDialog-paper': {
    width: 900,
    height: dialogHeight,
    maxWidth: 900,
    maxHeight: dialogHeight,
    backgroundColor: FORTA_WHITE,
    backgroundSize: '100%',
    boxShadow: `8px 8px 8px 0px rgba(74, 74, 74, 0.25)`,
    borderRadius: '8px',
    margin: 0,
    padding: '16px',
    border: `2px solid ${FORTA_BLUE.light3}`,
    ...dialogStyles,
  },
  '& .MuiDialogContent-root': {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
  },
  ...sx,
}));

function FHPreviewDialog(props: FHPreviewDialogProps) {
  const {
    open,
    title = '',
    colorTheme = Themes.Primary,
    onClose,
    contentRenderer,
    dialogStyles = {},
    closeIconDataTestId,
    titleStyles = {},
    showDownload = false,
    onDownload,
    ...rest
  } = props;

  return (
    <StyledDialog {...rest} open={open} dialogStyles={dialogStyles}>
      <DialogContent>
        <Box sx={FH_PREVIEW_DIALOG_HEADER_SX}>
          {title && (
            <Typography variant="h4" fontWeight={500} align="left" sx={{ ...titleStyles }}>
              {title}
            </Typography>
          )}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {showDownload ? (
              <IconButton
                sx={{ p: 0 }}
                title="Download"
                disableRipple
                onClick={onDownload}
                aria-label="Download"
              >
                <FileDownloadOutlined sx={{ color: getThemeColor(colorTheme).primary }} />
              </IconButton>
            ) : null}
            <IconButton
              data-testid={closeIconDataTestId}
              sx={{ p: 0 }}
              title="Close"
              disableRipple
              onClick={onClose}
            >
              <Close sx={{ color: getThemeColor(colorTheme).primary }} />
            </IconButton>
          </Box>
        </Box>
        <Box sx={FH_PREVIEW_DIALOG_CONTENT_SX}>{contentRenderer && contentRenderer()}</Box>
      </DialogContent>
    </StyledDialog>
  );
}

export default FHPreviewDialog;
